module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_iter-step.js
// module id = 608
// module chunks = 168707334958949